export default __webpack_public_path__ + "static/media/header.b2aa4085.png";